import React from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SaveIcon from "@mui/icons-material/Save";
import HomePageAutoCom from "../../ContentManagement/firstPage/HomePageAutoCom";

function Bread(props) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        height: "7%",
        p: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Typography color="inherit">
          {props.breadChilds.title ? props.breadChilds.title : ""}
        </Typography>
        {props.breadChilds.childs.map((child, i) => {
          if (
            child.targetID ||
            child.FAQsRes ||
            child.SlideID ||
            child.OfferID ||
            child.LandingID ||
            child.AdvID ||
            child.LanID ||
            child.websiteID ||
            child.CategoryID ||
            child.CatBoxID ||
            child.MagazineID ||
            child.componentFaTitle ||
            child.listId ||
            child.model ||
            child.scrollTo
          ) {
            return (
              <Link
                key={i}
                underline="hover"
                color="text.primary"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  if (child.websiteID) {
                    window.open(child.websiteID, "_blank");
                    return;
                  }
                  navigate(child.url, {
                    state: {
                      id: child.targetID ? child.targetID : "",
                      FAQsRes: child.FAQsRes && child.FAQsRes,
                      SlideID: child.SlideID && child.SlideID,
                      OfferID: child.OfferID && child.OfferID,
                      LandingID: child.LandingID && child.LandingID,
                      LanID: child.LanID && child.LanID,
                      AdvID: child.AdvID && child.AdvID,
                      CategoryID: child.CategoryID && child.CategoryID,
                      CatBoxID: child.CatBoxID && child.CatBoxID,
                      MagazineID: child.MagazineID && child.MagazineID,
                      scrollTo: child.scrollTo && child.scrollTo,
                      componentFaTitle:
                        child.componentFaTitle && child.componentFaTitle,
                      listId: child.listId && child.listId,
                      model: child.model && child.model,
                    },
                  });
                }}
              >
                {child.name}
              </Link>
            );
          } else {
            return (
              <Link
                underline="hover"
                color="text.primary"
                key={i}
                href={child.url}
              >
                {child.name}
              </Link>
            );
          }
        })}
      </Breadcrumbs>

      <Box sx={{ display: "flex" }}>
        {props.breadChilds.saveButton ? (
          <Tooltip title="ذخیره">
            <IconButton
              sx={{ ":hover": { boxShadow: 5 }, p: 0.5, boxShadow: 2, mr: 2 }}
              color="info"
              onClick={() => {
                props.breadChilds.saveButtonFunc();
              }}
              // startIcon={<SaveIcon />}
            >
              <SaveIcon />
              {/* ذخیره */}
            </IconButton>
          </Tooltip>
        ) : (
          ""
        )}
        {props.breadChilds.backButtonDef ? (
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              navigate(props.breadChilds.backURL, {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        ) : (
          ""
        )}
      </Box>
      {props.breadChilds.addOrderButton ? (
        <Button
          sx={{ width: "100px" }}
          variant="contained"
          color="secondary"
          onClick={() => {
            props.breadChilds.addOrderButton.setExpanded("panel1");
            props.breadChilds.addOrderButton.setState({
              OrderID: undefined,
              address: undefined,
              addressTitle: undefined,
              cityID: undefined,
              description: undefined,
              firstName: undefined,
              lastName: undefined,
              mobile: undefined,
              postCode: undefined,
              provinceID: undefined,
              reciver: undefined,
              deliveryID: undefined,
              deliveryType: undefined,
              phone: undefined,
              paymentType: undefined,
              OfflinePayCode: undefined,
              SendFactor: false,
              Confidential: false,
              SendSMS: false,
              notUsecraditDiscount: false,
            });
            props.breadChilds.addOrderButton.setOrderRes();
          }}
        >
          سفارش جدید
        </Button>
      ) : (
        ""
      )}
      {props.breadChilds.updateAll ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {props.breadChilds.updateAll.account && (
            <Button
              // sx={{ width: "200px" }}
              variant="contained"
              color="info"
              onClick={() =>
                props.breadChilds.updateAll.account.onclickAccount()
              }
            >
              اعتبار حساب
            </Button>
          )}
          <Button
            // sx={{ width: "200px" }}
            variant="contained"
            color="secondary"
            onClick={() => props.breadChilds.updateAll.onclick()}
          >
            به‌روزرسانی همه
          </Button>
        </Box>
      ) : (
        ""
      )}
      {props.breadChilds.HomePageAutoCom?.show ? (
        <HomePageAutoCom
          setter={(id) => {
            props.breadChilds.HomePageAutoCom.HomePageAutoComFunc(id);
          }}
        />
      ) : (
        ""
      )}
      {props.breadChilds.backButtonOrders ? (
        <Button
          sx={{ width: "100px" }}
          variant="contained"
          color="secondary"
          onClick={() => {
            navigate(
              `/orders?state=${location.state ? location.state.orderState : 1}`,
              {
                state: { ...location.state, isBack: true },
                replace: true,
              }
            );
          }}
        >
          بازگشت
        </Button>
      ) : (
        ""
      )}
    </Box>
  );
}
export default Bread;
